import React from 'react'
import alertImage from '../../static/images/alert.svg'

const AlertPage = props => {
    const { message, children } = props
    return (
        <div className="flex flex-col items-center mt-40 mb-20 gap-10">
            <img src={alertImage} alt="경고이미지" />
            <div className="text-4xl font-bold text-cyan-800">{message}</div>
            {children}
        </div>
    )
}

export default AlertPage
